import React from "react";

import Card from "../Card/Card";
import CardGrid from "../Card/CardGrid";
import LoadingCenter from "../LoadingCenter";

import { useHttp } from "../../hooks/useHttp";
import { useQuery } from "@tanstack/react-query";
import { AlertOctagon, MessageCircle } from "react-feather";

const CardsProspect = props => {
  const request = useHttp();
  const { data: dash, isLoading } = useQuery({ queryKey: ["dash-prospect"], queryFn: () => request({ url: "/dash/graph/op", method: "GET" }) });

  if (isLoading) return <LoadingCenter />;

  return (
    <CardGrid className="mt-20">
      <Card icon={<AlertOctagon />} title={dash?.data?.qtdArremates} subtitle="Arremates" color="primary" />

      <Card icon={<AlertOctagon />} title={dash?.data?.qtdChats} subtitle="Quantidade de chats" />

      <Card icon={<MessageCircle />} title={dash?.data?.qtdUsersTransfer} subtitle="Usuários transferidos" iconColor="blue" />
    </CardGrid>
  );
}

export default CardsProspect;